angular.module('rjmNg.directives').directive "chartTypeDescription", [
  () ->
    restrict: "E"
    templateUrl: "directive.chartTypeDescription.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      chartType: "="
      chartTypeLabel: "="
    controller: [
      () ->

        view = @

        chartTypeDescriptions = 
          line:
            definitionName: 'Lines'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            xAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          bar:
            definitionName: 'Bars'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            yAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          barstacked:
            definitionName: 'Stacked Bars'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            yAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          column:
            definitionName: 'Columns'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            xAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          columnstacked:
            definitionName: 'Stacked Columns'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            xAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          pie:
            definitionName: 'Pie Slices'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            timeInterval: 'Must be set to &#8220;<strong>None</strong>&#8221;'
          area:
            definitionName: 'Areas'
            definition: '<strong>Metrics</strong> and/or &#8220;<strong>Group bys</strong>&#8221;'
            xAxis: 'Selected <strong>Time Range</strong> or &#8220;<strong>Group bys</strong>&#8221;'
          funnel:
            definitionName: 'Funnel Size'
            definition: 'One <strong>Metric</strong>'
            funnelDivision: 'Selected <strong>Time Interval</strong> <br>OR <br>One selected &#8220;<strong>Group by</strong>&#8221; with Interval set to &#8220;<strong>None</strong>&#8221;'
          scatter:
            definitionName: 'Individual Plotted Points'
            definition: 'Defined by <strong>Group bys</strong> or <strong>Time Interval</strong>'
            xAxis: 'The first &#8220;<strong>Metric</strong>&#8221; selected'
            yAxis: 'The second &#8220;<strong>Metric</strong>&#8221; selected'
            SizeOfBubble: 'The third &#8220;<strong>Metric</strong>&#8221; selected'
            timeInterval: 'Must be set to &#8220;<strong>None</strong>&#8221; if <strong>Group by</strong> is selected'
          heatmap:
            definitionName: 'Heatmap Color Weight'
            definition: 'One selected <strong>Metric</strong>'
            heatmapYAxis: 'Selected &#8220;<strong>Group by</strong>&#8221;'
            heatmapXAxis: 'Selected &#8220;<strong>Time Interval by</strong>&#8221; </br> Or </br> Second selected <strong>Group by</strong> with time interval set to <strong>None</strong>'

        _getChartTypeDescription = (chartType) ->
          view.chartTypeDescription = chartTypeDescriptions[chartType]

        view.$onInit = () ->
          _getChartTypeDescription(view.chartType)
       
        return view
    ]
]